// Basis codes from suppliers come in various forms: plain ('BB', 'HB', 'FB'),
// with descriptive suffix ('HB 50 Min'), or as compound names ('BBClub').
// he.json only defines the canonical 2–3 letter codes, so a verbatim lookup
// leaves rooms with descriptive bases showing 'basis-name.hb 50 min' as text.
// This mixin resolves any code to its known prefix (longest first) and then
// translates, falling back to the raw code if no prefix matches.

const KNOWN_PREFIXES = ['all', 'bb', 'hb', 'fb', 'ro', 'al'];

export default {
  methods: {
    getBasisName(code) {
      if (!code) return '';
      const normalized = String(code).toLowerCase().trim();
      if (this.$te(`basis-name.${normalized}`)) {
        return this.$t(`basis-name.${normalized}`);
      }
      const prefix = KNOWN_PREFIXES.find((p) => normalized.startsWith(p));
      return prefix ? this.$t(`basis-name.${prefix}`) : code;
    },
  },
};
